import { DocumentIcon, PhotoIcon } from '@heroicons/react/24/outline';
import { isURLAnImage } from '@teetsh/app/src/components/Attachments/isUrlImage';
import { PDFIcon } from '@teetsh/app/src/components/Icons/icons/PDF';

export const getFileIcon = (downloadUrl: string) => {
  if (isURLAnImage(downloadUrl)) {
    return PhotoIcon;
  }
  if (downloadUrl.toLowerCase().endsWith('.pdf')) {
    return PDFIcon;
  }
  return DocumentIcon;
};
